import React from "react";
import {
  ResponsiveContainer,
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
} from "recharts";
import { C, F } from "@tokens";
import { useChartAnimation } from "./printMode";

/**
 * SessionsPerDayChart — gráfico de barras de série única (contagem/soma por
 * período). Reaproveitado para sessões por dia, sessões por mês e duração
 * por mês — mesma forma visual, só muda o eixo X e a métrica.
 * @param {Array}    data          - [{ [xKey]: string, [yKey]: number }]
 * @param {string}   [xKey]        - chave do eixo X (default "day")
 * @param {string}   [yKey]        - chave do valor (default "sessions")
 * @param {string}   [name]        - rótulo da série no tooltip
 * @param {string}   [color]       - cor da barra
 * @param {Function} [formatValue] - formata o valor no tooltip/eixo Y
 */
export default function SessionsPerDayChart({
  data = [],
  xKey = "day",
  yKey = "sessions",
  name = "Sessões",
  color = C.g600,
  formatValue,
  height = 260,
}) {
  const animarGraficos = useChartAnimation();
  return (
    <ResponsiveContainer width="100%" height={height}>
      <BarChart data={data} margin={{ top: 16, right: 16, left: 0, bottom: 8 }}>
        <CartesianGrid stroke={C.border} strokeDasharray="3 3" vertical={false} />
        <XAxis
          dataKey={xKey}
          stroke={C.text3}
          fontSize={11}
          tick={{ fontFamily: F.text }}
        />
        <YAxis
          stroke={C.text4}
          fontSize={10}
          allowDecimals={false}
          tick={{ fontFamily: F.text }}
          tickFormatter={formatValue}
        />
        <Tooltip
          contentStyle={{
            background: C.surface,
            border: `1px solid ${C.border}`,
            borderRadius: 10,
            fontSize: 11,
            fontFamily: F.text,
            boxShadow: "0 4px 16px rgba(0,0,0,.08)",
          }}
          cursor={{ fill: C.surf3 }}
          formatter={(value) => [formatValue ? formatValue(value) : value, name]}
        />
        <Bar isAnimationActive={animarGraficos} dataKey={yKey} name={name} fill={color} radius={[4, 4, 0, 0]} />
      </BarChart>
    </ResponsiveContainer>
  );
}
